"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Stepper = function Stepper(props) {
  return /*#__PURE__*/_react.default.createElement(_Stepper.default, _extends({
    alternativeLabel: true
  }, props));
};

var _default = Stepper;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1N0ZXBwZXIvU3RlcHBlci50c3giXSwibmFtZXMiOlsiU3RlcHBlciIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7O0FBR0EsSUFBTUEsT0FBNEIsR0FBRyxTQUEvQkEsT0FBK0IsQ0FBQ0MsS0FBRDtBQUFBLHNCQUFXLDZCQUFDLGdCQUFEO0FBQVksSUFBQSxnQkFBZ0I7QUFBNUIsS0FBaUNBLEtBQWpDLEVBQVg7QUFBQSxDQUFyQzs7ZUFFZUQsTyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGQyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IFN0ZXBwZXIgYXMgTXVpU3RlcHBlciwgU3RlcHBlclByb3BzIGFzIE11aVN0ZXBwZXJQcm9wcyB9IGZyb20gJ0BtYXRlcmlhbC11aS9jb3JlJztcblxuY29uc3QgU3RlcHBlcjogRkM8TXVpU3RlcHBlclByb3BzPiA9IChwcm9wcykgPT4gPE11aVN0ZXBwZXIgYWx0ZXJuYXRpdmVMYWJlbCB7Li4ucHJvcHN9IC8+O1xuXG5leHBvcnQgZGVmYXVsdCBTdGVwcGVyO1xuIl19